<template>
  <div class="u-line-clamp">
    <div v-bind="wrapperBindings">
      <slot />
    </div>

    <transition name="fade">
      <p v-if="isTruncated" :class="controlClass">
        <u-link :key="i18nPath" @click="isClamped = !isClamped">{{
          $t(i18nPath)
        }}</u-link>
      </p>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ULineClamp",
  props: {
    lines: { type: Number, default: 3 },
    forceOpen: { type: Boolean, default: false },
    controlClass: { type: String, default: "is-size-7 has-margin-top-50" }
  },
  data: () => ({
    isClamped: true,
    isTruncated: false
  }),
  computed: {
    wrapperBindings() {
      return {
        class: { "is-clamped": this.isClamped },
        style: { "--line-clamp": this.lines },
        ref: "clampWrapper"
      };
    },
    windowWidth(): number {
      return this.$store.state.ui.window.width;
    },
    navIsCollapsed(): boolean {
      return this.$store.getters["ui/navIsCollapsed"];
    },
    i18nPath() {
      return this.isClamped ? "_action.show_more_literal" : "_action.show_less";
    }
  },
  watch: {
    windowWidth: { handler: "setDefaultClampState" },
    navIsCollapsed: { handler: "setDefaultClampState" }
  },
  mounted() {
    setTimeout(this.setDefaultClampState, 200);
  },
  methods: {
    setDefaultClampState() {
      this.isClamped = !this.forceOpen;
      this.$nextTick(() => {
        this.isTruncated =
          (this.$refs.clampWrapper as Element)?.scrollHeight >
          (this.$refs.clampWrapper as Element)?.clientHeight;
      });
    }
  }
});
</script>

<style lang="scss" scoped>
.u-line-clamp {
  .is-clamped {
    display: -webkit-box;
    -webkit-line-clamp: var(--line-clamp, 2);
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  ::v-deep pre {
    white-space: pre-wrap !important;
  }
}
</style>
